<template>
  <v-row no-gutters>
    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field
        v-model="computedValue.name"
        :error-messages="errors.name"
        clearable
        dense
        label="نام"
        outlined
      />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field
        v-model="computedValue.quantity"
        :error-messages="errors.quantity"
        clearable
        dense
        label="تعداد (موجودی جایزه)"
        outlined
      />
    </v-col>

    <v-col class="pa-2" cols="12">
      آیکون
      <pic-selector
        :edit-name="false"
        :field.sync="computedValue.icon_path"
        one-pic
        single
      />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field
        v-model="computedValue.recharge_days"
        clearable
        dense
        hide-spin-buttons
        label="زمان شارژ شانس کاربر"
        outlined
        type="number"
      />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field
        v-model="computedValue.chance_percent"
        :error-messages="errors.chance_percent"
        append-icon="mdi-percent-outline"
        clearable
        dense
        hide-spin-buttons
        label="درصد انتخاب"
        outlined
        type="number"
      />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field
        v-model="computedValue.reward_value"
        clearable
        dense
        label="هدیه"
        outlined
      />
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <color-picker v-model="computedValue.color" label="رنگ" />
    </v-col>
  </v-row>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";

export default {
  components: { ColorPicker, PicSelector },

  props: {
    value: Object,
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped></style>
